module.exports = __webpack_public_path__ + "img/Element10_Fehler_Ziffernrechnen.094e4d2c.png";